var _effectorFileName = "/builds/gmini/front-common/src/hooks/useExplorerItemStyles.ts";
import { makeStyles } from '@mui/styles';
export var useExplorerItemStyles = makeStyles(function () {
  return {
    root: {
      paddingLeft: '19px',
      borderRadius: '4px',
      paddingTop: '3px',
      paddingBottom: '3px',
      gap: '8px',
      '&&.Mui-selected': {
        background: 'rgba(92, 130, 229, 0.15)'
      },
      '&& .MuiListItemText-root': {
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '21px',
        letterSpacing: '0.10000000149011612px'
      },
      '&& .MuiListItemIcon-root': {
        marginRight: 0,
        justifyContent: 'center'
      },
      '&:hover': {
        background: 'rgba(245, 245, 249, 1)'
      }
    },
    container: {
      width: '100%'
    }
  };
});